import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import { BMapLoader } from '@/utils/bdMap.js';
import { Notify } from 'vant';
import { sizeFilter, handleHttp, transformStr3, getformListItemsdatas, getFileStatus, formatToLine } from "@/utils/utils";
import { isHasLinkHandle, navigationUrl, getlastclickmarker, isMobile, getStr } from '@/view/map/js/common';
export default {
  // standardappmap
  name: 'sdAmap',
  meta: {
    title: '地图'
  },
  data() {
    return {
      activeName: 0,
      activeIndex: 0,
      map: null,
      requestType: '',
      bottompopshow: true,
      // 滑动bar相关字段
      startY: 0,
      endY: 0,
      distanceY: 0,
      flag: 1,
      popHeight: '20rem',
      contentHeight: '16.8rem',
      // 搜索相关字段
      formKey: 0,
      searchinput: '',
      searchplaceholder: '请搜索',
      // 获取标签表单数据
      formparams: {
        deptId: '',
        formId: '349949',
        page: 1,
        limit: 100,
        searchStr: '',
        orderBy: 'manualOrderTop,manualOrder'
      },
      tabsData: [],
      // 当前标签表单对应列表数据
      dataparams: {
        deptId: '',
        formId: '',
        page: 1,
        limit: 20,
        searchStr: '',
        orderBy: 'manualOrderTop,manualOrder'
      },
      // 当前列表信息相关字段
      datatotalPage: 1,
      datatotal: 0,
      dataList: [],
      currentPage: 1,
      currenIndex: 0,
      currendata: {},
      currentlistparams: [],
      currentdetailparams: [],
      currentlocationparam: '',
      currentlinkparam: '',
      crrrentstructData: [],
      currentTypeData: [],
      // 当前详情信息相关字段
      detailflag: false,
      infoDetail: {},
      isHasNav: '',
      infoDetailflag: false,
      otherinfo: [],
      condition: {
        model: 0,
        filters: []
      },
      loading: false,
      finished: false,
      finishednodatatext: '已经到底啦',
      finishedtext: '已经到底啦',
      nodata: false,
      selectmultiObj: {},
      typeDomtimer: null,
      scbtnflag: false,
      scflag: false,
      onceflag: '',
      point: {}
    };
  },
  created() {
    if (isMobile()) location.href = location.href.replace('standardmap', 'appmap');
    // 台州市图书馆 修改顺序排序
    if (this.$route.query.fid === '29168') {
      this.dataparams.orderType = 'asc';
      this.dataparams.orderBy = 'paixu';
    }
  },
  mounted() {
    document.querySelector('html').style.height = '100%';
    document.querySelector('body').style.height = '100%';
    document.querySelector('#app').style.height = '100%';
    this.formparams.deptId = this.$route.query.fid;
    // this.getTabsData()
    this.getAMap();
  },
  watch: {
    infoDetail(val) {
      if (val) {
        //console.log(val)
        this.otherinfo = val.filter((item, index) => {
          return index > 1 && item !== '';
        });
      }
    }
  },
  methods: {
    // 初始化百度地图
    getAMap() {
      this.$nextTick(() => {
        BMapLoader().then(BMap => {
          this.map = new BMap.Map('map');
          let geolocation = new BMap.Geolocation();
          geolocation.getCurrentPosition(a => {
            console.log(a);
            this.point = new BMap.Point(a.point.lng, a.point.lat);
            // this.map.centerAndZoom(this.point, 15)
          });
          this.map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
          // 添加中心点和缩放等级，如果不添加，初始化出来页面为白屏
          this.getTabsData();
        });
      });
    },
    getTabsData() {
      let that = this;
      this.formparams.deptId = this.$route.query.fid;
      this.$api.singleadvanceSearch(this.formparams).then(res => {
        let formData = [];
        let titleArr = [];
        that.loading = false;
        if (res.totalRow > 0) {
          let getSindex = 0;
          formData = res.dataList.map((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            item.itemformdata.index = index.toString();
            if (itemformat.typeparams !== '') {
              let typeArr = itemformat.typeparams.split(',');
              let typeData = [];
              typeArr.forEach((types, typesindex) => {
                let type = types.split('|');
                //console.log(type)
                typeData.push({
                  title: type[0],
                  param: type[1],
                  options: [],
                  index: '',
                  compt: ''
                });
              });

              // 获取对应表单字段结构
              let params = {
                deptId: itemformat.unitfid,
                formId: itemformat.unitformId
              };
              this.$api.formStruct(params).then(res => {
                getSindex++;
                if (res.length > 0) {
                  that.crrrentstructData = res;
                  //console.log(typeData)
                  typeData.forEach(typeitem => {
                    //console.log(typeitem.param)
                    res.forEach(stuctitem => {
                      if (typeitem.param === stuctitem.alias) {
                        // console.log(stuctitem)
                        typeitem.options = stuctitem.field.options;
                        typeitem.compt = stuctitem.compt;
                        that.selectmultiObj[typeitem.param] = [];
                      }
                    });
                  });
                  item.itemformdata.typeData = typeData;
                }
              });
            } else {
              getSindex++;
            }
            // console.log(item.itemformdata)
            that.tabsData.push(item.itemformdata);
            titleArr.push(itemformat.title);
            return item;
          });
          console.log(that.tabsData);
          that.searchplaceholder += titleArr.join('、');
          if (that.tabsData[0].selectcondition !== undefined && that.tabsData[0].selectcondition !== '') {
            let selectcondition = JSON.parse(that.tabsData[0].selectcondition);
            // console.log(selectcondition)
            let confilters = [];
            selectcondition.forEach(items => {
              if (items.compt === 'selectbox' || items.compt === 'radiobutton') {
                items.val = [items.val];
              }
              confilters.push([items]);
            });
            that.condition.filters = confilters;
            that.dataparams.searchStr = selectcondition !== '[]' ? encodeURI(JSON.stringify(that.condition)) : '';
          }
          // URL searchStr 优先覆盖 selectcondition（仅首屏）
          const urlFilters = that.parseUrlSearchStr();
          if (urlFilters) {
            that.condition.filters = urlFilters;
            that.dataparams.searchStr = encodeURI(JSON.stringify(that.condition));
          }

          // 通用地图基础配置 是否存在数据
          if (that.tabsData[0][44] && that.tabsData[0][44] !== '') {
            // that.isHasTitle = true
            // that.basicformUserId = that.tabsData[0].form[44]
            let form = {
              deptId: this.$route.query.fid,
              formId: 677917,
              limit: 20,
              searchStr: ''
            };
            this.$api.singleadvanceSearch(form).then(res => {
              res.dataList.map(elem => {
                let itemformdata = elem.formIdValueData;
                let itemformat = {};
                Object.keys(itemformdata).forEach(key => {
                  itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
                });
                elem.itemformdata = itemformat;
                if (elem.id === parseInt(that.tabsData[0][44])) {
                  console.log(elem);
                  // 网页标题
                  if (elem.itemformdata.toptitle && elem.itemformdata.toptitle !== '') {
                    document.title = elem.itemformdata.toptitle;
                  }
                  // 搜索自定义
                  if (elem.itemformdata.searchtitle.length !== 0 && elem.itemformdata.searchtitle !== '') {
                    that.searchplaceholder = elem.itemformdata.searchtitle;
                  }
                  // 颜色自定义
                  if (elem.itemformdata.jsontxt) {
                    let jsontxt = JSON.parse(getStr(elem.itemformdata.jsontxt));
                    document.documentElement.style.setProperty('--basic-maptheme', jsontxt.styleOption.themecolor);
                  }
                }
                return elem;
              });
            });
          }
          if (formData[0].itemformdata.typeparams === '') {
            that.defaultsearchparams(that.tabsData[0]);
            return;
          }
          console.log(`getSindex`, getSindex);
          console.log(`res.dataList.length`, res.dataList.length);
          // 解决表单结构字段接口数据未获取到问题
          this.timer = setInterval(() => {
            if (getSindex === res.dataList.length) {
              clearInterval(that.timer);
              that.defaultsearchparams(that.tabsData[0]);
              // console.log(that.tabsData[0])
            }
          }, 500);
        }
      });
    },
    /* 获取列表数据前 坐标点的判断 */
    onload() {
      // console.log(this.dataList)
      this.getList();
    },
    // 默认搜索字段
    defaultsearchparams(current) {
      this.dataparams.deptId = current.unitfid;
      this.dataparams.formId = current.unitformId;
      this.dataparams.mapSettingfid = current.unitfid;
      this.dataparams.page = 1;
      this.dataparams.limit = 20;
      this.currentlistparams = current.listparams.split(',');
      this.currentdetailparams = current.detailparams.split(',');
      this.currentlocationparam = current.locationparam;
      this.currentlinkparam = current.linkparam;
      this.currentTypeData = current.typeData;
      this.syncFilterUI();
      console.log(this.currentTypeData);
      this.getList();
    },
    // 解析 URL 上的 searchStr，返回 condition.filters 数组；非法则返回 null
    parseUrlSearchStr() {
      const raw = this.$route.query.searchStr;
      if (!raw) return null;
      try {
        let decoded = raw;
        try {
          decoded = decodeURIComponent(raw);
        } catch (e) {/* vue-router 可能已解码 */}
        const parsed = JSON.parse(decoded);
        return Array.isArray(parsed) ? parsed : null;
      } catch (e) {
        console.error('invalid searchStr', e);
        return null;
      }
    },
    // 根据 condition.filters 同步筛选条选中样式
    syncFilterUI() {
      if (!this.currentTypeData || !this.condition.filters || this.condition.filters.length === 0) return;
      this.condition.filters.forEach(filterGroup => {
        const filter = filterGroup && filterGroup[0];
        if (!filter || !filter.alias) return;
        this.currentTypeData.forEach(typeItem => {
          if (typeItem.param !== filter.alias || !typeItem.options || typeItem.options.length === 0) return;
          if (filter.compt === 'selectbox' || filter.compt === 'radiobutton') {
            const val = Array.isArray(filter.val) ? filter.val[0] : filter.val;
            const opIndex = typeItem.options.findIndex(opt => opt.title === val);
            if (opIndex !== -1) typeItem.index = opIndex;
          } else if (filter.compt === 'selectmultibox' || filter.compt === 'checklist') {
            const vals = Array.isArray(filter.val) ? filter.val : [filter.val];
            this.selectmultiObj[typeItem.param] = [];
            typeItem.options.forEach((opt, idx) => {
              if (vals.indexOf(opt.title) !== -1) {
                this.selectmultiObj[typeItem.param].push(idx);
              }
            });
          }
        });
      });
    },
    getList() {
      let that = this;
      if (this.onceflag !== this.activeIndex) {
        this.onceflag = this.activeIndex;
        this.typeDomtimer = setTimeout(() => {
          let typebox = that.$refs['custom-typeBox-style1'];
          if (typebox && typebox.offsetHeight !== '') {
            clearTimeout(that.typeDomtimer);
            console.log(typebox.offsetHeight);
            that.scbtnflag = typebox.offsetHeight > 200 ? true : false;
          }
        }, 500);
      }
      this.$api.map_search(this.dataparams).then(res => {
        let formData = [];
        that.datatotalPage = res.totalPage;
        console.log(that.datatotalPage);
        if (res.totalRow > 0) {
          that.nodata = false;
          that.loading = false;
          that.finished = false;
          formData = res.dataList.map((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            let sortindex = that.dataparams.limit * (that.dataparams.page - 1) + (index + 1);
            item.sortindex = sortindex;
            item.itemformdata = itemformat;
            let showparams = [];
            that.currentlistparams.forEach((items, indexs) => {
              let params = items.split('|');
              if (params.length > 1 && params[1].includes('_')) {
                params[1] = transformStr3(params[1]);
              }
              if (indexs === 0) {
                items !== '' ? showparams.push(item.itemformdata[params[1]].length === 0 ? '' : handleHttp('https://pan-yz.chaoxing.com/thumbnail/origin/' + item.itemformdata[params[1]][0].objectId)) : showparams.push('');
              } else {
                if (item.itemformdata[params[1]].length > 0 || typeof item.itemformdata[params[1]] === 'string' && item.itemformdata[params[1]] !== '') {
                  // 列表 第二个字段 标题 标红 处理
                  if (that.searchinput !== '' && indexs === 1) {
                    if (item.itemformdata[params[1]].indexOf(that.searchinput) > -1) {
                      let title = item.itemformdata[params[1]].replace(that.searchinput, '<i>' + that.searchinput + '</i>');
                      item.itemformdata[params[1]] = title;
                    }
                  }
                  let paramsvalue = '';
                  if (item.itemformdata[params[1]][0].address) {
                    paramsvalue = item.itemformdata[params[1]][0].address;
                  } else {
                    paramsvalue = item.itemformdata[params[1]];
                  }
                  showparams.push('<span class="label">' + params[0] + '</span>' + paramsvalue);
                } else {
                  showparams.push('');
                }
              }
            });
            item.itemformdata.showparams = showparams;
            return item;
          });
          that.datatotal = res.totalRow;
          if (that.datatotalPage === 1) {
            that.dataList = formData;
            that.finished = true;
            that.finishedtext = that.finishednodatatext;
          } else {
            if (that.dataparams.page === 1) {
              that.dataList = formData;
            } else {
              that.dataList = that.dataList.concat(formData);
              console.log(that.dataparams.page);
              console.log(that.datatotalPage);
              console.log(that.dataparams.page === that.datatotalPage);
              if (that.dataparams.page === that.datatotalPage) {
                that.finished = true;
                that.finishedtext = that.finishednodatatext;
              }
            }
            that.dataparams.page++;
          }
          if (that.currentlocationparam === '') {
            Notify('当前表单未选择定位字段，不显示定位点');
            that.map.clearOverlays();
            return;
          }
          that.createMarker();
        } else {
          that.dataList = [];
          that.datatotal = res.totalRow;
          that.finished = true;
          that.finishedtext = '';
          that.nodata = true;
          that.map.clearOverlays();
        }
        setTimeout(() => {
          that.scflag = true;
        }, 1000);
      });
    },
    createMarker() {
      if (this.dataparams.page === 1) {
        this.map.clearOverlays();
      }
      let marker = null;
      let list = this.dataList;
      let bPoints = [];
      if (list.length > 0) {
        for (let i in list) {
          let point = list[i];
          for (let i in point.itemformdata) {
            let pointitem = point.itemformdata[i];
            if (pointitem.length > 0 && pointitem[0].lat) {
              let Bpoint = new BMapGL.Point(pointitem[0].lng, pointitem[0].lat);
              bPoints.push(Bpoint);
              // 创建文本标注
              marker = new BMapGL.Label('<span class="pointMarker">' + point.sortindex + '</span>', {
                position: Bpoint
              });
              marker.addEventListener('click', this.markerClickHandler);
              marker.sid = point.id;
              // console.log(Bmarker)
              this.map.addOverlay(marker);
            }
          }
        }
        let _this = this;
        setTimeout(function () {
          _this.setZoom(bPoints);
        }, 1000);
      }
    },
    setZoom(bPoints) {
      let view = this.map.getViewport(eval(bPoints));
      let mapZoom = view.zoom;
      let centerPoint = view.center;
      this.map.centerAndZoom(centerPoint, mapZoom);
    },
    // 坐标点点击事件
    markerClickHandler(event) {
      //   console.log(event.target)
      this.fnInitSiteInfo(event.target);
    },
    fnInitSiteInfo(target) {
      this.infoDetail = {};
      for (let i in this.dataList) {
        if (this.dataList[i].id === target.sid) {
          let item = this.dataList[i];
          this.currendata = item;
          if (this.currentlocationparam !== '') {
            this.isHasNav = this.currendata.itemformdata[transformStr3(this.currentlocationparam)];
          }
          // console.log(item.itemformdata)
          let showparams = [];
          this.currentdetailparams.forEach((items, indexs) => {
            let params = items.split('|');
            console.log(params);
            if (params.length > 1 && params[1].includes('_')) {
              params[1] = transformStr3(params[1]);
            }
            if (indexs === 0) {
              items !== '' ? showparams.push(item.itemformdata[params[1]].length === 0 ? '' : handleHttp('https://pan-yz.chaoxing.com/thumbnail/origin/' + item.itemformdata[params[1]][0].objectId)) : showparams.push('');
            } else {
              // console.log(item.itemformdata[params[1]])
              // console.log(typeof(item.itemformdata[params[1]]))
              if (item.itemformdata[params[1]].length > 0 || typeof item.itemformdata[params[1]] === 'string' && item.itemformdata[params[1]] !== '') {
                if (typeof item.itemformdata[params[1]] !== 'string') {
                  let params1val = item.itemformdata[params[1]][0].address !== undefined ? item.itemformdata[params[1]][0].address : '';
                  item.itemformdata[params[1]] = params1val;
                }
                let paramsvalue = '';
                if (item.itemformdata[params[1]].length > 0 && item.itemformdata[params[1]][0].address) {
                  paramsvalue = item.itemformdata[params[1]][0].address;
                } else {
                  paramsvalue = typeof item.itemformdata[params[1]] === 'string' && item.itemformdata[params[1]] !== '' ? item.itemformdata[params[1]] : item.itemformdata[params[1]][0].val !== '' ? item.itemformdata[params[1]][0].val : '';
                }
                showparams.push('<span class="label">' + params[0] + '</span>' + paramsvalue);
              } else {
                showparams.push('');
              }
            }
          });
          this.infoDetail = showparams;
          let infocontent = this.$refs.infoBox;
          this.map.setCenter(target.getPosition());
          let infoWindow = new BMapGL.InfoWindow(infocontent, {
            width: 300
          });
          this.map.openInfoWindow(infoWindow, target.getPosition());
          this.infoDetailflag = true;
        }
      }
    },
    mapinfopoint() {
      isHasLinkHandle(this.currentlinkparam, this.currendata);
    },
    itemnavigation(val) {
      let name = this.infoDetail[1].split('</span>')[1];
      navigationUrl(val, name);
    },
    getLastClickMarker(markerId) {
      return getlastclickmarker(this.map, markerId);
    },
    // 点击列表触发
    listpoint(val) {
      // 是否有外链
      // console.log(val)
      let currentTarget = this.getLastClickMarker(val.id);
      if (currentTarget) {
        this.fnInitSiteInfo(currentTarget);
      } else {
        isHasLinkHandle(this.currentlinkparam, val);
      }
    },
    // tab标签点击事件
    handleClick(val) {
      console.log(val);
      this.activeName = val.title;
      this.activeIndex = val;
      this.currentPage = 1;
      let index = val;
      this.scbtnflag = false;
      this.scflag = false;
      this.currentTypeData = this.tabsData[index].typeData;
      if (this.currentTypeData !== undefined) {
        this.currentTypeData = this.currentTypeData.map(item => {
          item.index = '';
          return item;
        });
      }
      let selectcondition = '[]';
      if (this.tabsData[index].selectcondition !== undefined && this.tabsData[index].selectcondition !== '[]') {
        selectcondition = JSON.parse(this.tabsData[index].selectcondition);
        // console.log(selectcondition)
        let confilters = [];
        selectcondition.forEach(items => {
          if (items.compt === 'selectbox' || items.compt === 'radiobutton') {
            items.val = [items.val];
          }
          confilters.push([items]);
        });
        this.condition.filters = confilters;
      }
      console.log(this.condition.filters);
      if (this.searchinput !== '') {
        this.searchStruct(this.tabsData[index]);
        return;
      }
      this.dataparams.searchStr = selectcondition !== '[]' ? encodeURI(JSON.stringify(this.condition)) : '';
      this.defaultsearchparams(this.tabsData[index]);
    },
    // 清除搜索文本触发
    searchdelete() {
      this.searchinput = '';
      this.activeName = 0;
      this.activeIndex = 0;
      if (this.tabsData[0].selectcondition !== undefined && this.tabsData[0].selectcondition !== '') {
        let selectcondition = JSON.parse(this.tabsData[0].selectcondition);
        // console.log(selectcondition)
        let confilters = [];
        selectcondition.forEach(items => {
          if (items.compt === 'selectbox' || items.compt === 'radiobutton') {
            items.val = [items.val];
          }
          confilters.push([items]);
        });
        this.condition.filters = confilters;
        this.dataparams.searchStr = selectcondition !== '[]' ? encodeURI(JSON.stringify(this.condition)) : '';
      }
      this.dataparams.searchStr = this.condition;
      this.dataparams.searchStr = encodeURI(JSON.stringify(this.dataparams.searchStr));
      this.defaultsearchparams(this.tabsData[0]);
    },
    // 搜索
    searchname() {
      let params = this.tabsData[parseInt(this.activeIndex)];
      this.searchStruct(params);
    },
    searchStruct(val) {
      let that = this;
      let params = {
        deptId: val.unitfid,
        formId: val.unitformId
      };
      this.$api.formStruct(params).then(res => {
        let searchitem = val.listparams.split(',')[1];
        let searchalias = searchitem.split('|')[1];
        if (res.length > 0) {
          that.crrrentstructData = res;
          res.forEach(item => {
            if (item.alias === searchalias) {
              let searcharr = [{
                "alias": item.alias,
                "compt": item.compt,
                "express": "like",
                "id": 0,
                "val": that.searchinput
              }];
              let isHasSearchparams = that.condition.filters.filter(items => {
                return items[0].id === 0;
              });
              console.log(isHasSearchparams);
              if (isHasSearchparams.length > 0) {
                that.condition.filters.forEach(items => {
                  if (items[0].id === 0) items[0].val = that.searchinput;
                });
              } else {
                that.condition.filters.push(searcharr);
              }
              that.dataparams.searchStr = that.condition;
              that.dataparams.searchStr = encodeURI(JSON.stringify(that.dataparams.searchStr));
              that.defaultsearchparams(val);
            }
          });
        }
      });
    },
    // 类型选择
    selectType(alias, title, opindex, index, compt, item) {
      // 处理复选类型 选中状态
      if (item !== undefined) {
        if (this.selectmultiObj[alias] && this.selectmultiObj[alias].indexOf(opindex) !== -1) {
          this.selectmultiObj[alias].splice(this.selectmultiObj[alias].indexOf(opindex), 1);
        } else {
          if (!this.selectmultiObj[alias]) this.selectmultiObj[alias] = [];
          this.selectmultiObj[alias].push(opindex);
        }
      }
      if (title === '' && this.selectmultiObj[alias]) this.selectmultiObj[alias] = [];
      // 选中当前类型
      this.currentTypeData = this.currentTypeData.map((items, indexs) => {
        if (items.param === alias) {
          items.index = opindex;
        }
        return items;
      });

      // 选中后拼凑搜索字段
      if (this.condition.filters.length > 0) {
        let isHasAlias = this.condition.filters.filter((items, indexs) => {
          return items[0].alias === alias;
        });
        if (isHasAlias.length > 0) {
          if (title !== '') {
            if (compt === 'selectbox') {
              isHasAlias[0][0].val = [title];
            } else {
              isHasAlias[0][0].val.indexOf(title) !== -1 ? isHasAlias[0][0].val.splice(isHasAlias[0][0].val.indexOf(title), 1) : isHasAlias[0][0].val.push(title);
            }
          } else {
            this.condition.filters = this.condition.filters.filter((items, indexs) => {
              return items[0].alias !== alias;
            });
          }
        } else {
          this.condition.filters.push([{
            "alias": alias,
            "compt": compt,
            "express": compt === "selectbox" ? "===" : "match",
            "id": index + 1,
            "val": [title]
          }]);
        }
      } else {
        if (title !== '') {
          this.condition.filters.push([{
            "alias": alias,
            "compt": compt,
            "express": compt === "selectbox" ? "===" : "match",
            "id": index + 1,
            "val": [title]
          }]);
        }
      }
      let activeName = parseInt(this.activeName);
      this.dataparams.searchStr = this.condition;
      this.dataparams.searchStr = encodeURI(JSON.stringify(this.dataparams.searchStr));
      this.defaultsearchparams(this.tabsData[this.activeName]);
    },
    /* 滑动触摸开始事件 */
    handleTouchStart(e) {
      this.endY = e.touches[0].pageY;
    },
    /* 滑动触摸滑动事件 */
    handleTouchMove(e) {
      this.startY = e.touches[0].pageY;
    },
    /* 滑动触摸结束事件 */
    handleTouchEnd(e) {
      this.distanceY = this.startY - this.endY;
      if (this.distanceY > 0 && Math.abs(this.distanceY) >= 50) {
        if (this.flag >= 1) return;
        this.flag++;
        if (this.flag === 1) {
          this.popHeight = '20rem';
          this.contentHeight = '16.8rem';
        }
      } else if (this.distanceY < 0 && Math.abs(this.distanceY) >= 50) {
        if (this.flag < 0) return;
        this.flag--;
        if (this.flag === 0) {
          this.popHeight = '33rem';
          this.contentHeight = '29.3rem';
        }
      }
    }
  }
};